// Environment-aware API host configuration
// Prefers explicitly-set environment variable, otherwise uses sensible defaults

const explicitHost = (process.env.REACT_APP_API_HOST || '').trim();

// Default hosts per environment
const DEFAULT_HOSTS = {
  development: 'http://localhost:5785',
  test: 'http://localhost:5785',
  production: 'https://api.veso79.vn',
};

const ENV = process.env.NODE_ENV || 'development';

// Selection priority:
// 1. Use REACT_APP_API_HOST if explicitly provided
// 2. Otherwise, use environment-specific default
export const host = explicitHost || DEFAULT_HOSTS[ENV] || DEFAULT_HOSTS.production;

const explicitCrawlerHost = (process.env.REACT_APP_CRAWLER_HOST || '').trim();
const DEFAULT_CRAWLER_HOSTS = {
  development: 'http://localhost:8081',
  test: 'http://localhost:8081',
  production: 'https://crawler.veso79.vn',
};
export const crawlerHost = explicitCrawlerHost || DEFAULT_CRAWLER_HOSTS[ENV] || DEFAULT_CRAWLER_HOSTS.production;

export const RSA_PUBLIC_KEY =
  "-----BEGIN PUBLIC KEY-----\n" +
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhEKxDENVH8MN/w1uPpAN\n" +
  "TDGoLP9a4BefeocwSWE1AZGPROKvNeOnyhoqVK04lCW5IPsRt2KiRPEZ9u56rIqp\n" +
  "IpNEo3cVwLwFTZz0iLi1eBCsZzrc1j1uXQwM8I/037Qrc3jlTGNzv2r6wSCNzTwo\n" +
  "V6VCAGEx7oeM2W+ozvJP7IWlmJLH9cZdeJLDLuAwpssDQ82gA1S3m6GvJkhMjhUb\n" +
  "5iarhc1zPM49jEOXEWn40amGQKCYcjsiZzz+3a0PIhDfAWqXYfNyx9gg+tA8QVQa\n" +
  "bNdkZVBZG7KrfbtsJX4GAZR261/pUfA25AzRnkQFE0S0COboGp+9xBBLtEBAFrCh\n" +
  "ywIDAQAB\n" +
  "-----END PUBLIC KEY-----";
